export default __webpack_public_path__ + "static/noissue-tv-left-73a5d5085b5bd0fd082f30336c4ddcc5.svg";